import React, { memo, Fragment } from 'react';
import { func, shape, arrayOf } from 'prop-types';

import SubcategoryBanner from './SubcategoryBanner';

const SubcategoryBanners = ({ activeFilters, onCheckboxChange }) => {
    const renderBanner = activeFilter => {
        const { options, id } = activeFilter;

        if (!options || !options.length) {
            return null;
        }

        return (
            <Fragment key={id}>
                {options.map(({ subcategoriesContent }) => {
                    if (!subcategoriesContent) {
                        return null;
                    }

                    return (
                        <Fragment key={subcategoriesContent.title}>
                            <SubcategoryBanner
                                {...subcategoriesContent}
                                filterId={id}
                                onChange={onCheckboxChange}
                            />
                        </Fragment>
                    );
                })}
            </Fragment>
        );
    };

    if (!activeFilters || !activeFilters.length) {
        return null;
    }

    return (
        <div className="listing-subcategory-banners">
            {activeFilters.map(renderBanner)}
        </div>
    );
};

SubcategoryBanners.propTypes = {
    activeFilters: arrayOf(shape({})).isRequired,
    onCheckboxChange: func.isRequired
};

export default memo(SubcategoryBanners);
